import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { default as localeEs } from '@angular/common/locales/es';
import { CoreModule } from '@core/core.module';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { OnDemandPreloadStrategy } from '@core/preloaders/on-demand-preload.strategy';
import { LoadingInterceptor } from '@core/interceptors/loading.interceptor';
import { BuildInfoStore } from '@core/build/build-info.store';
import { BuildIdTranslateLoader } from '@core/i18n/build-id-translate-loader';

function initializeBuildInfo(buildInfoStore: BuildInfoStore) {
    return () => buildInfoStore.load();
}

registerLocaleData(localeEs, 'es');

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        NgProgressModule.withConfig({
            thick: true,
            spinner: false,
            color: '#f05050',
        }),
        NgProgressRouterModule,
        NgProgressHttpModule,
        RouterModule.forRoot(appRoutes, {
            useHash: true,
            preloadingStrategy: OnDemandPreloadStrategy,
            onSameUrlNavigation: 'reload',
            // enableTracing: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: BuildIdTranslateLoader,
            },
        }),
        CoreModule
	],
	providers: [
		{
            provide: APP_INITIALIZER,
            useFactory: initializeBuildInfo,
            deps: [BuildInfoStore],
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }
    ],
})
export class AppModule { }
